import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function StickyTopBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-[#E74C3C] text-white py-2 px-4 text-center shadow-md" data-id="element-230">
      <p className="text-sm md:text-base font-medium flex items-center justify-center gap-2 flex-wrap" data-id="element-231">
        <span data-id="element-232">🔥 Esta oferta termina pronto —</span>
        <span className="bg-white/20 px-2 py-1 rounded font-mono" data-id="element-233">
          <CountdownTimer data-id="element-234" />
        </span>
      </p>
    </div>;
}